import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#2C2C2C]">
      {/* Upper Footer */}
      <div className="py-14 md:py-20">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-12">
            {/* Column 1 - About */}
            <div className="col-span-2 md:col-span-1">
              <div className="flex items-center mb-4">
                <img
                  src="https://static.readdy.ai/image/3968a368ec7bd5d344dd8c774c671405/4a7e3fde1e9f243c2f3bcc38a0bb7863.png"
                  alt="CLOG Transport Logo"
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-sm text-[#9E9E9E] leading-relaxed">
                Professional subcontract transport services supporting established logistics operators across Northern Territory.
              </p>
            </div>

            {/* Column 2 - Location */}
            <div>
              <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-4 font-semibold">
                LOCATION
              </h3>
              <p className="text-[15px] text-white leading-relaxed">
                Darwin<br />
                Northern Territory<br />
                Australia
              </p>
            </div>

            {/* Column 3 - Quick Links */}
            <div>
              <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-4 font-semibold">
                QUICK LINKS
              </h3>
              <div className="space-y-3">
                <Link to="/" className="block text-[15px] text-white hover:text-[#D97642] transition-colors cursor-pointer">Home</Link>
                <Link to="/about" className="block text-[15px] text-white hover:text-[#D97642] transition-colors cursor-pointer">About</Link>
                <Link to="/services" className="block text-[15px] text-white hover:text-[#D97642] transition-colors cursor-pointer">Services</Link>
                <Link to="/contact" className="block text-[15px] text-white hover:text-[#D97642] transition-colors cursor-pointer">Contact</Link>
              </div>
            </div>

            {/* Column 4 - Contact */}
            <div>
              <h3 className="text-xs text-gray-400 uppercase tracking-wider mb-4 font-semibold">
                CONTACT
              </h3>
              <div className="space-y-3">
                <p className="text-sm md:text-[15px] text-white break-all">contact@clogtransport.com.au</p>
                <p className="text-[15px] text-white">0414 968 280</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-[#404040]">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-6 md:py-8">
          <p className="text-[13px] text-[#9E9E9E] text-center">
            © 2025 CLOG TRANSPORT. Professional transport support services in Darwin, NT.
          </p>
        </div>
      </div>
    </footer>
  );
}
